import { render, staticRenderFns } from "./label-manage.vue?vue&type=template&id=27bc601b&"
import script from "./label-manage.vue?vue&type=script&lang=js&"
export * from "./label-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports